import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API, BAG_STATUS, ENVIRONMENT, FLIGHT_STATUS, HELP_OPTION_CODES, MAX_CALLOUT_RETRIES, STORAGE_KEYS } from 'src/app/_constants/app.constants';
import { HelpOptionsRequest, HelpOptionsResponse } from 'src/app/_models/user';
import { AuthService } from '../auth/auth.service';
import { FlightService } from 'src/app/_services/api/flight/flight.service';
import { LoggerService } from 'src/app/_services/ui/logger/logger.service';
import { SessionService } from 'src/app/_services/session/session.service';
import { AppModule } from 'src/app/app.module';
import { ServiceModule } from 'src/app/_services/service.module';
import { catchError, of } from 'rxjs';

@Injectable({
  providedIn: ServiceModule
})
export class HelpOptionsService {

  private _currentHelpOptions: HelpOptionsResponse = { options: PRIMARY_OPTIONS, secondary: true };

  get helpOptions(): HelpOptionsResponse {
    return this._currentHelpOptions;
  }


  constructor(
    private http: HttpClient,
    private logger: LoggerService,
    private authService: AuthService,
    private sessionService: SessionService,
    private flightService: FlightService
  ) { }


  /**
  *
  * Makes a callout and sets the api value to the service
  *
  */
  async getHelpOptions(isPreChat = false, retryCount = 0) {
    this.logger.debug('help options service: getHelpOptions()', arguments);
    let url = `${ENVIRONMENT.PROPERTIES.apiUrl}${API.HELP_OPTIONS}`;
    let body: HelpOptionsRequest = {
      action: 'GET_HELP_OPTIONS',
      gate: this.sessionService?.locationData['gate-number'],
      airport: this.sessionService?.locationData['airport-code'],
      routingCode: this.sessionService?.locationData['routing-code'],
      flightStatus: this.flightService?.activeSegment?.legStatus,
      destination: this.flightService?.activeSegment?.arrivalAirport?.iataCode,
      bagCount: Number(this.flightService?.activeTraveler?.bagCount?.match(/\d+/g)) || 0,
      isFinalDestination: this.flightService?.activeSegment?.isFinalDestination,
      isInternational: this.flightService?.flightDetails?.isInternational,
      hasDelayedBag: this.flightService?.activeTraveler?.bagStatus?.some(status => status.status.indexOf(BAG_STATUS.DELAYED) >= 0),
      allBagsArrived: this.flightService?.activeTraveler?.bagStatus === null || this.flightService?.activeTraveler?.bagStatus?.every(status => status.status.indexOf(BAG_STATUS.ARRIVED) >= 0),
      hasArrivedFlight: this.flightService?.flightDetails?.segments?.some(segment => segment.legStatus == FLIGHT_STATUS.ARRIVED_AT_GATE),
      isCheckedIn: this.flightService?.activeTraveler?.isCheckedIn === 'True' ? true : false,
      isEncryptedStringInParams: this.sessionService.isEncryptedStringInParams,
      isPreChat: isPreChat
    }
    let headers = new HttpHeaders({
      'Hostname': this.authService.getHostName(),
      'Xsrf': this.authService.token
    })

    let options = isPreChat ? PRIMARY_OPTIONS_PRE_CHAT : PRIMARY_OPTIONS;
    this.setHelpOptions({ options, secondary: true });

    let response: any = await new Promise((res: any, rej: any) => {
      this.http.post(encodeURI(url), body, { headers }).pipe(
        catchError(err => {
          return of({ success: false })
        })
      ).subscribe((data: any) => {
        res(data)
      })
    })

    // await this.http.post(encodeURI(url), body, { headers }).toPromise().catch(e => e)

    if ((response instanceof Error) == false) {
      this.logger.debug('Help options service : getHelpOptions() response', response);
      if (response["success"]) {
        this.setHelpOptions(response.data);

      } else {
        if (retryCount == MAX_CALLOUT_RETRIES) return;

        if (response['code'] == 403) {
          try {
            await this.authService.refreshToken();
            this.logger.debug('Help options service : getHelpOptions() : Token refresh');
            await this.getHelpOptions(isPreChat, ++retryCount);
            this.logger.debug('Help options service : getHelpOptions() : Retry getHelpOptions() :: Success');
          } catch (e) {
            this.logger.debug('Help options service : getHelpOptions(): Auth failed : Exception', e);
            throw e;
          }
        } else return;
      }
    }
  }

  /**
   * set the current help-options to the service variable
   */
  setHelpOptions(currentHelpOptions) {
    this.logger.debug('help options service :: setHelpOptions() ', currentHelpOptions);
    this._currentHelpOptions = currentHelpOptions;
  }

  /**
   * clears the current help-options saved
   */
  clearHelpOptions() {
    this.logger.debug('help options service :: clearHelpOptions() ');
    this._currentHelpOptions = null;
  }

}

const PRIMARY_OPTIONS = [HELP_OPTION_CODES.DOC_CHECK, HELP_OPTION_CODES.FLIGHT_CHANGE, HELP_OPTION_CODES.SEAT_CHANGE, HELP_OPTION_CODES.BAGGAGE];

export const PRIMARY_OPTIONS_PRE_CHAT = [HELP_OPTION_CODES.FLIGHT_CHANGE, HELP_OPTION_CODES.SEAT_CHANGE, HELP_OPTION_CODES.DOC_CHECK, HELP_OPTION_CODES.BAGGAGE];